import type { CountryCodes } from '@onevesthq/ov-enums';
import { AccountTypeSelect } from '@ovComponents/3-pattern/accountTypeSelect/accountTypeSelect';
import type { FieldRequiredType } from '@ovComponents/4-module/configurableOptionFields/basicField';
import type { TransferContextData } from '@ovComponents/4-module/workflowCompletion/workflowTypes';
import { useLocalization } from '../../../../../../hooks/useLocalization';
import { showsRequiredFieldError } from '../depositFieldErrors';

type AccountTypeOption = {
  required?: FieldRequiredType;
  label?: unknown;
};

export type DepositExternalTransferAccountTypeProp = {
  accountType?: string;
  option?: AccountTypeOption;
  focused: string[];
  onFocus: (field: string) => void;
  onChange: (value: Partial<TransferContextData>) => void;
  usOriginOfAccount?: CountryCodes;
};

export const DepositExternalTransferAccountType = ({
  accountType,
  option,
  focused,
  onFocus,
  onChange,
  usOriginOfAccount,
}: DepositExternalTransferAccountTypeProp) => {
  const { translateBackendString } = useLocalization();

  return (
    <AccountTypeSelect
      size='medium'
      label={translateBackendString(option?.label)}
      onChange={(e: any) => onChange({ accountType: e })}
      value={accountType}
      onBlur={() => onFocus('institution')}
      error={showsRequiredFieldError({
        missing: !accountType,
        field: 'accountType',
        focused,
        requirement: option?.required,
      })}
      originOfAccount={usOriginOfAccount}
      bypassFilteringByAvailableFeatureFlags={Boolean(usOriginOfAccount)}
    />
  );
};
